import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
	Modal,
	Box,
	DialogTitle,
	DialogContent,
	DialogContentText
} from '@mui/material';
import SuccessImgIcon from '../../Assets/Images/EsignGatewaySuccess.svg';
import RejectedImgIcon from '../../Assets/Images/EsignGatewayReject.svg';
import EsignGatewayNotify from '../../Assets/Images/EsignGatewayNotify.svg';
import PrimaryButton from './Button/primary-button.js';

const styles = {
	title: {
		fontFamily: 'Gilroy-Medium',
		fontSize: '20px',
		fontWeight: 400,
		lineHeight: '24px',
		letterSpacing: '0em',
		textAlign: 'center'
	},
	message: {
		fontFamily: 'Gilroy-Medium',
		fontSize: '14px',
		lineHeight: '16px',
		letterSpacing: '0em',
		textAlign: 'center',
		color: '#646464'
	},
	content: {
		backgroundColor: 'white',
		padding: '40px 16px 20px',
		borderRadius: '8px',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		width: '100%'
	},
	modalContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	successImg: {
		transform: 'translateY(50%)',
		zIndex: 1,
		position: 'relative'
	}
};

const SuccessRejectModal = ({
	open,
	onClose,
	title,
	message,
	onActionClick,
	actionLabel,
	displayedRecipients,
	displayedAwaitingRecipient,
	modalContentWidth,
	type,
	center,
	Notify,
	isNotify = false
}) => {
	const [showAll, setShowAll] = useState(false);
	const initialDisplayCount = 2;
	let currentColorIndex = 0;
	let currentTestColorIndex = 0;

	const handleClose = () => {
		onClose(false);
		if (onActionClick) {
			onActionClick();
		}
	};

	const displayedRecipient = showAll
		? displayedRecipients
		: displayedRecipients?.slice(0, initialDisplayCount);
	const displayedAwaiting = showAll
		? displayedAwaitingRecipient
		: displayedAwaitingRecipient?.slice(0, initialDisplayCount);

	const getNextColor = () => {
		const colors = ['#fbfdf0', '#fff9d8', '#fcefed'];
		const nextColor = colors[currentColorIndex];
		currentColorIndex = (currentColorIndex + 1) % colors.length;
		return nextColor;
	};

	const getTextNextColor = () => {
		const colors = ['#D3E966', '#FFDA15', '#E9BC66'];
		const nextColor = colors[currentTestColorIndex];
		currentTestColorIndex = (currentTestColorIndex + 1) % colors.length;
		return nextColor;
	};

	const toggleShowAll = () => {
		setShowAll(!showAll);
	};

	const renderRecipients = (isAwaiting = false) => (
		<div
			style={{ display: 'flex', flexDirection: 'column', paddingTop: '20px' }}
		>
			<p style={{ fontSize: '12px', color: '#646464' }}>Recipients</p>
			<div style={{ maxHeight: '270px', overflow: 'auto' }}>
				{isNotify
					? ((isAwaiting && displayedAwaiting) || displayedRecipient)?.map(
						(recipient, idx) => (
							<div
								key={'notify-index' + idx}
								style={{
									display: 'flex',
									alignItems: 'center',
									padding: '5px 0'
								}}
							>
								<div
									className='recipientsDetails'
									style={{
										backgroundColor: getNextColor(),
										color: getTextNextColor(),
										border: '1px solid',
										alignItems: 'center',
										height: '40px',
										width: '40px'
									}}
								>
									{recipient.recipientName
										.split(' ')
										.map((word) => word[0])
										.filter(Boolean)
										.join('')
										.toUpperCase()}
								</div>
								<div>
									<p className='recipientName' style={{ fontSize: '14px' }}>
										{recipient?.recipientName || ''}
									</p>
									<p
										className='recipientEmail'
										style={{ color: '#8E8E8E', fontSize: '12px' }}
									>
										{recipient?.emailId || ''}
									</p>
								</div>
							</div>
						)
					)
					: ((isAwaiting && displayedAwaiting) || displayedRecipient)?.map(
						(recipient) => (
							<div
								key={isAwaiting ? recipient.recipientId : recipient.id}
								style={{
									display: 'flex',
									alignItems: 'center',
									padding: '5px 0'
								}}
							>
								<div
									className='recipientsDetails'
									style={{
										backgroundColor: getNextColor(),
										color: getTextNextColor(),
										border: '1px solid',
										alignItems: 'center',
										height: '40px',
										width: '40px'
									}}
								>
									{isAwaiting
										? [
											recipient?.firstName?.[0],
											recipient?.middleName?.[0],
											recipient?.lastName?.[0]
										]
											.filter(Boolean)
											.join('')
											.toUpperCase()
										: [
											recipient?.userData.firstName?.[0],
											recipient?.userData.middleName?.[0],
											recipient?.userData.lastName?.[0]
										]
											.filter(Boolean)
											.join('')
											.toUpperCase()}
								</div>
								<div>
									<p className='recipientName' style={{ fontSize: '14px' }}>
										{`${[recipient?.firstName, recipient?.middleName, recipient?.lastName].filter(Boolean).join(' ')}`}
									</p>
									<p
										className='recipientEmail'
										style={{ color: '#8E8E8E', fontSize: '12px' }}
									>
										{isAwaiting
											? recipient?.emailId
											: recipient?.userData.email}
									</p>
								</div>
							</div>
						)
					)}
			</div>
			{!showAll
				&& (isAwaiting
					? displayedAwaitingRecipient?.length > initialDisplayCount
					: displayedRecipients?.length > initialDisplayCount) && (
				<Box onClick={toggleShowAll}>
					<p
						style={{ color: '#B7D423', cursor: 'pointer', padding: '5px 0' }}
					>
							Show More
					</p>
				</Box>
			)}
			{showAll && (
				<Box onClick={toggleShowAll}>
					<p style={{ color: '#B7D423', cursor: 'pointer', padding: '5px 0' }}>
						Show Less
					</p>
				</Box>
			)}
		</div>
	);

	return (
		<Modal open={open} style={styles.modalContent}>
			<Box
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					width: modalContentWidth
				}}
			>
				<div>
					<img
						src={
							Notify === true
								? EsignGatewayNotify
								: (type === 'Approval' && SuccessImgIcon) || RejectedImgIcon
						}
						alt='Success'
						style={styles.successImg}
					/>
				</div>
				<div style={styles.content}>
					<DialogTitle sx={styles.title}>{title}</DialogTitle>
					<DialogContent sx={{ padding: '0 5px 16px' }}>
						<DialogContentText
							sx={styles.message}
							style={{
								display: center ? 'flex' : null,
								justifyContent: center ? 'center' : null
							}}
						>
							{message}
						</DialogContentText>
						{displayedRecipients
							&& displayedRecipients.length > 0
							&& renderRecipients()}
						{displayedAwaitingRecipient
							&& displayedAwaitingRecipient.length > 0
							&& renderRecipients(true)}
					</DialogContent>
					<div>
						<PrimaryButton
							value={actionLabel}
							onClick={handleClose}
							width='100%'
							textcolor={type === 'Approval' ? '#000' : '#fff'}
							backgroundColor={type === 'Approval' ? '#B7D423' : '#E96666'}
							padding='8px 16px'
							borderRadius='8px'
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default SuccessRejectModal;

SuccessRejectModal.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	title: PropTypes.any,
	message: PropTypes.any,
	onActionClick: PropTypes.any,
	actionLabel: PropTypes.any,
	displayedRecipients: PropTypes.any,
	displayedAwaitingRecipient: PropTypes.any,
	modalContentWidth: PropTypes.any,
	type: PropTypes.any,
	center: PropTypes.any,
	Notify: PropTypes.any,
	isNotify: PropTypes.any
};
